import { normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, openBlock as _openBlock, createElementBlock as _createElementBlock, mergeProps as _mergeProps, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, Fragment as _Fragment } from "vue";
const _hoisted_1 = {
    key: 1,
    style: { "display": "flex" }
};
const _hoisted_2 = { style: { "height": "100%", "vertical-align": "middle", "margin": "auto", "padding-right": "15px" } };
const _hoisted_3 = ["href"];
const _hoisted_4 = { class: "g-version" };
const _hoisted_5 = { class: "g-version__title" };
const _hoisted_6 = {
    title: "Status: OK",
    class: "g-version__status"
};
const _hoisted_7 = { class: "g-version__info" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_g_color_badge = _resolveComponent("g-color-badge");
    return (_openBlock(), _createElementBlock(_Fragment, null, [
        (_ctx.logoMode === 'simple')
            ? (_openBlock(), _createElementBlock("img", _normalizeProps(_mergeProps({ key: 0 }, _ctx.logoSimple)), null, 16))
            : _createCommentVNode("", true),
        (_ctx.logoMode === 'default')
            ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                    _createElementVNode("a", {
                        href: _ctx.$appHost.config.publicUrl ?? '#',
                        target: "_blank"
                    }, [
                        _createElementVNode("img", _normalizeProps(_guardReactiveProps(_ctx.logoDefault)), null, 16)
                    ], 8, _hoisted_3)
                ]),
                _createElementVNode("div", _hoisted_4, [
                    _createElementVNode("div", _hoisted_5, [
                        _createTextVNode(_toDisplayString(_ctx.$appHost.config.title) + " ", 1),
                        _createElementVNode("span", _hoisted_6, [
                            _createVNode(_component_g_color_badge, {
                                variant: _ctx.versionVariant,
                                rounded: true
                            }, null, 8, ["variant"])
                        ])
                    ]),
                    _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.$appHost.config.versionName), 1)
                ])
            ]))
            : _createCommentVNode("", true)
    ], 64));
}
